import { ref, computed } from 'vue';
export default {
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      required: true
    },
    isImage: {
      type: Boolean,
      default: false
    }
  },
  setup(props) {
    // eslint-disable-next-line
    const {
      icon,
      isImage
    } = props;
    const isImg = ref(isImage);
    // eslint-disable-next-line
    const iconName = computed(() => isImage ? require(`@/icons/images/${icon}`) : `#icon-${icon}`);
    return {
      isImg,
      iconName
    };
  }
};